import { Component, OnInit } from '@angular/core';

import { StateService } from '../../services/state.service';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { Order } from '../../../orders/models/order';
import { OrderService } from '../../../orders/services/order.service';
import { ModalService } from '../../services/modal.service';

@Component({
    selector: 'static-layout',
    templateUrl: './static-layout.component.html',
    styleUrls: ['./static-layout.component.sass', './static-layout.component.css'],
    standalone: false
})

export class StaticLayoutComponent implements OnInit {

    constructor(
        private stateService: StateService,
        private authService: AuthService,
        private router: Router,
        private orderService: OrderService,
        private modalService: ModalService
    ){}

    currentUser: any;
    orders = Array<Order>();
    currentYear = new Date().getFullYear();

    onActivate(event:any) {
        window.scroll(0, 0);
    }

    ngOnInit() {
        this.stateService.currentUser.changes.subscribe(user => {
            if(user == null || user.id == null) return;
            if(!this.authService.isAuthenticated()) return;
            this.currentUser = user;
            this.orderService.getOrders().subscribe( orders => this.orders = orders );
        });
    }

    showTracker(): boolean {
        return this.isAuthenticated();
    }

    login(): void {
        this.authService.login();
    }

    logout(): void {
        this.authService.logout();
    }

    isAuthenticated(): boolean {
        return this.authService.isAuthenticated();
    }

    goToLegacyRegistry() {
        var options = {
            message: `Our brand new SGC Registry is coming soon!
            
            In the meantime, if you wish to use our current registry, please click on "Go to Legacy Registry" and you will be redirected to the old site.`,
            actionLabel: 'Go To Legacy Registry',
            actionCallback: () => window.open('https://sgclegacy.com/registrymain.aspx', '_blank')
        }

        this.modalService.open('feature-coming-soon', options);
    }

    goToLegacyPopulationReport() {
        var options = {
            message: `Our brand new SGC Population Report is coming soon!
            
            In the meantime, if you wish to use our current Population Report, please click on "Go to Legacy Pop Report" and you will be redirected to the old site.`,
            actionLabel: 'Go To Legacy Pop Report',
            actionCallback: () => window.open('https://sgclegacy.com/PopulationReport.aspx', '_blank')
        }

        this.modalService.open('feature-coming-soon', options);
    }
}
